import React from "react";
import { Label } from "../../../../components/ui/label";
import { Input } from "../../../../components/ui/input";
import { FieldError } from "../FieldError";
import { useWatch } from "react-hook-form";

export function MotorCarrierNumber({ control, register }) {
  const carrier = useWatch({ control, name: "step2.carrier" });

  const isTargetCarrier = React.useMemo(() => {
    if (Array.isArray(carrier)) {
      return carrier.includes("Accelerant") || carrier.includes("Progressive");
    }
    return carrier === "Accelerant" || carrier === "Progressive";
  }, [carrier]);

  React.useEffect(() => {
    register("step2.motorCarrierNumber");
  }, [register]);

  if (!isTargetCarrier) {
    return null;
  }

  return (
    <div className="space-y-2">
      <Label htmlFor="motorCarrierNumber">Motor Carrier Number</Label>
      <Input
        id="motorCarrierNumber"
        placeholder="Enter..."
        {...register("step2.motorCarrierNumber")}
      />
      <FieldError name="step2.motorCarrierNumber" step="step2" control={control} />
    </div>
  );
}
